import HtmlNode from '../Extension/HtmlNode';
import ModalBody from './ModalBody';
import ModalCenter from './ModalCenter';
import ModalClose from './ModalClose';
import ModalContainer from './ModalContainer';
import ModalDialog from './ModalDialog';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import { MarketCode } from '../../@types/MarketCode';

interface ModalProps {
  readonly title: string;
  readonly id: string;
  readonly logo?: string;
  readonly logo2x?: string;
  readonly market?: MarketCode;
  readonly onClose?: () => void;
}

class Modal extends HtmlNode {
  private readonly props: ModalProps;
  content: HTMLElement;

  constructor(element: HTMLElement, props: ModalProps) {
    super(element, {
      htmlTag: 'div',
      className: 'waykevaluation-modal',
      attributes: [
        {
          key: 'role',
          value: 'dialog',
        },
        { key: 'aria-modal', value: 'true' },
        { key: 'aria-labelledby', value: 'wayke-valuation-title' },
      ],
      id: props.id,
    });
    this.props = props;
    this.content = this.render();
  }

  render() {
    const { title, id, logo, logo2x, market, onClose } = this.props;
    const container = new ModalContainer(this.node, { id: `${id}-container` });
    const center = new ModalCenter(container.node, { id: `${id}-center` });
    const dialog = new ModalDialog(center.node, { id: `${id}-dialog` });
    new ModalClose(dialog.node, { id: `${id}-close`, onClose });
    new ModalHeader(dialog.node, {
      title,
      id: `${id}-header`,
      logo,
      logo2x,
      market,
      onClose,
    });
    const body = new ModalBody(dialog.node, {
      id: `${id}-body`,
    });
    new ModalFooter(dialog.node, {
      id: `${id}-footer`,
      market,
    });
    return body.node;
  }
}

export default Modal;
